export const routes = {
  login: '/login',
  forgotPassword: '/forgot-password',

  dashboard: '/',

  orders: '/orders',
  order: (id = ':id') => `/orders/${id}`,
  orderEdit: (id = ':id') => `/orders/${id}/edit`,

  customers: '/customers',
  customer: (id = ':id') => `/customers/${id}`,

  products: '/products',
  productEdit: (id = ':id') => `/products/${id}/edit`,
  bundles: '/products/bundles',

  installations: '/installations',
  installation: (id = ':id') => `/installations/${id}`,

  devices: '/devices',
  device: (id = ':id') => `/devices/${id}`,

  support: '/support',
  ticket: (id = ':id') => `/support/${id}`,

  subscriptions: '/subscriptions',
  payments: '/payments',

  reports: '/reports',
  reportOrders: '/reports/orders',
  reportDeviceCount: '/reports/device-count',
  reportDeviceActivity: '/reports/device-activity',
  reportCustomerUsage: '/reports/customer-usage',
  reportSubscription: '/reports/subscription',

  notifications: '/notifications',
  activityLog: '/activity-log',

  configurations: '/configurations',
  configTax: '/configurations/tax',
  configDiscounts: '/configurations/discounts',
  configInstallationFees: '/configurations/installation-fees',
  configWarrantyPeriods: '/configurations/warranty-periods',

  adminUsers: '/admin-users',
  adminUserEdit: (id = ':id') => `/admin-users/${id}/edit`,

  notFound: '/404',
  serverError: '/500',
} as const;
